module.exports = __webpack_public_path__ + "img/plumbing.df0effd4.jpg";